import { format } from "date-fns";
import Filter from "../../components/usuarios/Filtros";
import Usuario from "../../components/usuarios/Usuario";
import { Rol } from "../../../utils/Rol";
import { useMediaQuery } from "react-responsive";

const Usuarios = ({
  filter,
  setFilter,
  fetch,
  data,
  setData,
  onClick,
  onChange,
  provincias,
  navigate,
  user,
  setLoading
}) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });


  return (
    <div className="min-vh-100">
      <div className="px-3">
        <div className="row">
          <div className="col-md-12">
            <Filter
              filter={filter}
              setFilter={setFilter}
              fetch={fetch}
              onChange={onChange}
              provincias={provincias}
              setData={setData}
            />
          </div>

          <div className="col-md-12">

            <div
              className="d-none d-md-flex flex-column flex-sm-row justify-content-between align-items-center my-4"
              style={{
                marginLeft: isDesktop ? "10vw" : "0px",
                marginRight: isDesktop ? "10vw" : "0px",
              }}
            >
              <div className="mb-2 mb-sm-0">
                <small className="text-muted">
                  Mostrando <span className="fw-medium">EVENTOS {data?.total}</span>
                </small>
              </div>

              <div>
                {data.links.map((link) => {
                  if (link.label == "&laquo; Previous") {
                    return (
                      <label
                        className={`btn btn-outline-dark me-1 ${link.active ? "active" : ""
                          } ${link.url ? "" : "disabled"}`}
                        onClick={() => {
                          let params = {
                            ...filter,
                            page: data.current_page - 1,
                          };

                          setLoading(true);
                          setFilter({
                            ...params,
                          });

                          fetch(setData, params, "/usuarios", null, setLoading);
                        }}
                      >
                        <i class="bi bi-chevron-left"></i>
                        ANTERIOR
                      </label>
                    );
                  }
                  if (link.label == "Next &raquo;") {
                    return (
                      <label
                        className={`btn btn-outline-dark ${link.active ? "active" : ""
                          } ${link.url ? "" : "disabled"}`}
                        onClick={() => {
                          let params = {
                            ...filter,
                            page: data.current_page + 1,
                          };

                          setLoading(true);
                          setFilter({
                            ...params,
                          });

                          fetch(setData, params, "/usuarios", null, setLoading);
                        }}
                      >
                        SIGUIENTE
                        <i class="bi bi-chevron-right"></i>
                      </label>
                    );
                  }
                  return (
                    <label
                      className={`btn btn-outline-dark me-1 ${link.active ? "active" : ""
                        }`}
                      onClick={() => {
                        let params = {
                          ...filter,
                          page: link.label,
                        };

                        setLoading(true);
                        setFilter({
                          ...params,
                        });

                        fetch(setData, params, "/usuarios", null, setLoading);
                      }}
                    >
                      {link.label}
                    </label>
                  );
                })}
              </div>
            </div>

            <div
              className="card d-none d-lg-block"
              style={{
                marginRight: "10vw",
                marginLeft: "10vw",
              }}
            >
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>ID</th>
                      <th>NOMBRE</th>
                      <th>EMAIL</th>
                      <th>ROL</th>
                      <th>CREADO</th>
                      <th>ESTADO</th>
                      <th>ACCIONES</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.data.map((usuario) => {
                      return (
                        <tr>
                          <td className="Grifter d-none d-md-table-cell">#{usuario.id}</td>
                          <td className="d-none d-md-table-cell">{usuario.nombre}</td>
                          <td className="d-none d-md-table-cell">{usuario.email}</td>
                          <td className="d-none d-md-table-cell">{Rol(usuario.rol[0].nombre)}</td>
                          <td className="d-none d-md-table-cell">
                            {format(new Date(usuario.created_at), "dd/M/yyyy").toString()}
                          </td>
                          <td className="d-none d-md-table-cell">
                            <div class="dropdown">
                              <button
                                class="btn text-dark border fw-normal GothamBold px-3 py-2 fs-10 dropdown-toggle"
                                style={{ borderRadius: "10px" }}
                                type="button"
                                id="dropdownMenuButton1"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                {usuario.status.nombre}
                              </button>
                              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li>
                                  <label className="btn m-0 p-0">
                                    <i class="text-success mx-1 bi bi-check-circle-fill"></i>
                                    Activar
                                    <button
                                      className="d-none"
                                      name="status"
                                      onClick={(event) =>
                                        onClick(event, { usuario: usuario, status: 1 })
                                      }
                                    ></button>
                                  </label>
                                </li>
                                <li>
                                  <label className="btn m-0 p-0">
                                    <i class="text-secondary mx-1 bi bi-slash-circle-fill"></i>
                                    Pausar
                                    <button
                                      className="d-none"
                                      name="status"
                                      onClick={(event) =>
                                        onClick(event, { usuario: usuario, status: 3 })
                                      }
                                    ></button>
                                  </label>
                                </li>
                                <li>
                                  <label className="btn m-0 p-0">
                                    <i class="text-info mx-1 bi bi-recycle"></i>
                                    Borradores
                                    <button
                                      className="d-none"
                                      name="status"
                                      onClick={(event) =>
                                        onClick(event, { usuario: usuario, status: 4 })
                                      }
                                    ></button>
                                  </label>
                                </li>
                                <li>
                                  <label className="btn m-0 p-0 d-none">
                                    <i class="text-danger mx-1 bi bi-trash"></i>
                                    Eliminar
                                    <button
                                      className="d-none"
                                      name="status"
                                      onClick={(event) =>
                                        onClick(event, { usuario: usuario, status: 5 })
                                      }
                                    ></button>
                                  </label>
                                </li>
                              </ul>
                            </div>
                          </td>

                          <td>
                            <label className={`btn btn-success me-1 mb-1 `}>
                              <i class="bi bi-pencil-square"></i>
                              <button
                                className="d-none"
                                name="editar-usuario"
                                onClick={(e) => onClick(e, usuario.id)}
                              ></button>
                            </label>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>


            <div
              className="d-none d-md-flex flex-column flex-sm-row justify-content-between align-items-center my-4"
              style={{
                marginLeft: isDesktop ? "10vw" : "0px",
                marginRight: isDesktop ? "10vw" : "0px",
              }}
            >
              <div className="mb-2 mb-sm-0">
                <small className="text-muted">
                  Mostrando <span className="fw-medium">EVENTOS {data?.total}</span>
                </small>
              </div>

              <div>
                {data.links.map((link) => {
                  if (link.label == "&laquo; Previous") {
                    return (
                      <label
                        className={`btn btn-outline-dark me-1 ${link.active ? "active" : ""
                          } ${link.url ? "" : "disabled"}`}
                        onClick={() => {
                          let params = {
                            ...filter,
                            page: data.current_page - 1,
                          };

                          setLoading(true);
                          setFilter({
                            ...params,
                          });

                          fetch(setData, params, "/usuarios", null, setLoading);
                        }}
                      >
                        <i class="bi bi-chevron-left"></i>
                        ANTERIOR
                      </label>
                    );
                  }
                  if (link.label == "Next &raquo;") {
                    return (
                      <label
                        className={`btn btn-outline-dark ${link.active ? "active" : ""
                          } ${link.url ? "" : "disabled"}`}
                        onClick={() => {
                          let params = {
                            ...filter,
                            page: data.current_page + 1,
                          };

                          setLoading(true);
                          setFilter({
                            ...params,
                          });

                          fetch(setData, params, "/usuarios", null, setLoading);
                        }}
                      >
                        SIGUIENTE
                        <i class="bi bi-chevron-right"></i>
                      </label>
                    );
                  }
                  return (
                    <label
                      className={`btn btn-outline-dark me-1 ${link.active ? "active" : ""
                        }`}
                      onClick={() => {
                        let params = {
                          ...filter,
                          page: link.label,
                        };

                        setLoading(true);
                        setFilter({
                          ...params,
                        });

                        fetch(setData, params, "/usuarios", null, setLoading);
                      }}
                    >
                      {link.label}
                    </label>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Usuarios